import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "plugin-management"
    }}>{`Plugin management`}</h1>
    <p>{`The UXP Developer Tool allows you to create plugins from templates and add existing ones to your developer workspace.`}</p>
    <h2 {...{
      "id": "creating-a-new-plugin"
    }}>{`Creating a new plugin`}</h2>
    <p>{`You can, of course, create a plugin manually -- but using a template can be the fastest way to get started. To create a plugin from the Developer Tool, follow these steps:`}</p>
    <ul>
      <li parentName="ul">{`Click *`}<em parentName="li">{`Create Plugin...`}</em>{`.`}</li>
      <li parentName="ul">{`A "Create Plugin" dialog appears.`}</li>
      <li parentName="ul">{`Supply a plugin name in the `}<strong parentName="li">{`Plugin Name`}</strong>{` field.`}</li>
      <li parentName="ul">{`Supply a plugin ID in the `}<strong parentName="li">{`Plugin Id`}</strong>{` field. During development you can use any identifier you want (as long as it's unique from any other plugin on your system), but for publication, you'll need one from the `}<a parentName="li" {...{
          "href": "https://console.adobe.io/home"
        }}>{`Adobe Developer Console`}</a>{`.`}</li>
      <li parentName="ul">{`Enter the plugin's version in the `}<strong parentName="li">{`Plugin Version`}</strong>{` field.`}</li>
      <li parentName="ul">{`From the `}<strong parentName="li">{`Host Application`}</strong>{` field, select `}<strong parentName="li">{`Adobe Photoshop`}</strong>{`.`}</li>
      <li parentName="ul">{`Enter `}<inlineCode parentName="li">{`23.0.0`}</inlineCode>{` as the minimum version in the `}<strong parentName="li">{`Host Application Version`}</strong>{` field. Earlier versions of Photoshop do not support plugins written with UXP. Of course, if your plugin needs features from a later version of Photoshop, you can enter a higher version here.`}</li>
      <li parentName="ul">{`Select one of the templates from the `}<strong parentName="li">{`Template`}</strong>{` field. The "ps-starter" template will provide a simple plugin with no additional frameworks, whereas the "ps-react-starter" will provide a plugin that's based on React.`}</li>
      <li parentName="ul">{`Click `}<strong parentName="li">{`Select Folder`}</strong>{`.`}</li>
      <li parentName="ul">{`Select where you want the plugin to reside. Note that the plugin files will be created `}<em parentName="li">{`in the folder you select`}</em>{`, so if you want the plugin to have its own folder, make sure to create a new folder in this dialog.`}</li>
    </ul>
    <p>{`Once the plugin files are created, the plugin will show up in the Tool's workspace.`}</p>
    <h2 {...{
      "id": "adding-an-existing-plugin"
    }}>{`Adding an existing plugin`}</h2>
    <p>{`You're not limited to creating new plugins from the Developer Tool – you can add plugins that you've already started as well.`}</p>
    <ul>
      <li parentName="ul">{`Click `}<strong parentName="li">{`Add Plugin...`}</strong>{` (if you've not added any plugins, this will read `}<strong parentName="li">{`Add Existing Plugin...`}</strong>{`)`}</li>
      <li parentName="ul">{`A file picker will appear. This picker expects you to pick the `}<inlineCode parentName="li">{`manifest.json`}</inlineCode>{` in your plugin folder.`}</li>
      <li parentName="ul">{`Once you close the picker, the plugin will be added to your workspace.`}</li>
    </ul>
    <h2 {...{
      "id": "removing-a-plugin"
    }}>{`Removing a plugin`}</h2>
    <p>{`If you're building a lot of plugins, you may find that the workspace may be getting cluttered. You can remove a plugin from the workspace by checking the plugin's associated checkbox and clicking `}<strong parentName="p">{`Remove Selected`}</strong>{` (in the upper-right corner). `}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Removing a plugin from the Developer Tool's workspace does `}<strong parentName="p">{`not`}</strong>{` remove the plugin from your storage. You can always add the plugin back later.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      